// Port of api/fuel/app/classes/model/game/family.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'game_family',
	prefix: '',
	key: 'game_family_id',
	fields: {
		game_family_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		family_id: Model.SCHEMA_NUMBER
	}
})
